<template>
  <div class="wrap-header">
    <div class="header">
      <div class="brand">
        <div class="humberger-icon" @click="openToggle">
          <label class="sidebarIconToggle">
            <div class="spinner diagonal part-1" :class="{ diagonaltop: status }"></div>
            <div class="spinner horizontal" :class="{ centerLine: status }"></div>
            <div class="spinner diagonal part-2" :class="{ diagonalbottom: status }"></div>
          </label>
        </div>
      </div>
      <!-- <div class="live-time">{{ currentDate }} {{ liveTime }}</div> -->
      <div class="user">
        <dropdown>
          <template slot="toggler">
            {{ username }}
            <i class="fa fa-sort-down"></i>
          </template>
          <dropdown-content>
            <div class="item-dropdown my-1 px-3 py-2" @click="logout">Logout</div>
          </dropdown-content>
        </dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Dropdown from "../utility/dropdown/Dropdown.vue";
import DropdownContent from "../utility/dropdown/DropdownContent.vue";

export default {
  components: {
    Dropdown,
    DropdownContent,
  },
  data() {
    return {
      dataToggle: false,
      status: false,
      username: "",
      liveTime: null,
      currentDate: null,
    };
  },
  mounted() {
    this.username = sessionStorage.getItem("username");
    let date = new Date();
    this.currentDate = moment(date).format("dddd, DD MMMM YYYY");
  },
  created() {
    setInterval(() => {
      this.showLiveTime();
    }, 1000);
  },
  methods: {
    showLiveTime() {
      let date = new Date();
      this.liveTime = moment(date).format("HH:mm:ss");
    },
    toggle() {
      this.dataToggle = !this.dataToggle;
    },
    logout() {
      sessionStorage.clear();
      delete axios.defaults.headers.common["Authorization"];
      this.$router.go("/login");
    },
    openToggle() {
      this.status = !this.status;
      // console.log(this.status);
      this.$emit("toggleSide", this.status);
      this.$root.$emit("toggleSide", this.status);
    },
  },
};
</script>

<style scoped>
/* .wrap-header {
 
} */

/* .mini {
  width: calc(100% - 70px);
} */

.live-time {
  font-size: 14px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.item-dropdown {
  line-height: 1.5;
}

.content-dropdown {
  right: 0;
  top: 2.5em;
}

.user {
  position: relative;
}

.user div {
  cursor: pointer;
}

.active-dropdown {
  display: inline-block;
}

.dropdown-header {
  position: absolute;
  right: 0;
  border: solid 1px rgba(112, 112, 112, 0.4);
  -webkit-box-shadow: 0 0px 5px 0 rgba(10, 10, 10, 0.76);
  box-shadow: 0 0px 2px 0 rgba(1, 2, 5, 0.55);
  width: 170px;
  border-radius: 5px;
  background: #fff;
}

.dropdown-header li {
  color: #2c3e50;
  cursor: pointer;
  /* padding: 10px 15px; */
  line-height: 35px;
}

.dropdown-header li:hover {
  color: #6495ed;
}

.humberger-icon {
  position: absolute;
  left: 20px;
  top: 25px;
}
.sidebarIconToggle {
  transition: all 0.3s;
  box-sizing: border-box;
  cursor: pointer;
  position: absolute;
  z-index: 99;
  height: 100%;
  width: 100%;
  height: 22px;
  width: 22px;
}
.spinner {
  transition: all 0.3s;
  box-sizing: border-box;
  position: absolute;
  height: 3px;
  width: 100%;
  background-color: #0d1d2c;
}

.horizontal {
  transition: all 0.3s;
  box-sizing: border-box;
  position: relative;
  float: left;
  margin-top: 3px;
}
.diagonal.part-1 {
  position: relative;
  transition: all 0.3s;
  box-sizing: border-box;
  float: left;
}
.diagonal.part-2 {
  transition: all 0.3s;
  box-sizing: border-box;
  position: relative;
  float: left;
  margin-top: 3px;
}

input[type="checkbox"] {
  transition: all 0.3s;
  box-sizing: border-box;
  display: none;
}

/* input[type=checkbox]:checked ~  */
.sidebarIconToggle > .centerLine {
  transition: all 0.3s;
  box-sizing: border-box;
  opacity: 0;
}
/* input[type=checkbox]:checked ~  */
.sidebarIconToggle > .diagonaltop {
  transition: all 0.3s;
  box-sizing: border-box;
  transform: rotate(135deg);
  margin-top: 8px;
}
/* input[type=checkbox]:checked ~  */
.sidebarIconToggle > .diagonalbottom {
  transition: all 0.3s;
  box-sizing: border-box;
  transform: rotate(-135deg);
  margin-top: -9px;
}
</style>
